import React, { useState, useEffect, useRef } from "react";
import { Skeleton, Tooltip } from "@mui/material";
import ReactPaginate from "react-paginate";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import Messages from "../../../constants/Messages";
import handleError from "../../../constants/handleError";
import AddCustomer from "./AddCustomer";
import EditCutomer from "./EditCustomer";
import DeleteModal from "../../../constants/DeleteModal";
import { Link, useNavigate } from "react-router-dom";
import { usePermission } from "../../../context/PermissionContext";
import CustomerView from "./CustomerView";
import Button from "../recharge/Button";
import AddGroup from "./AddGroup";
import EditGroup from "./EditGroup";
import { useAuth } from "../../../context/AuthProvider";
import useKeyboardTableNavigation from "../../../constants/useKeyboardTableNavigation";
import Table from "../../../constants/Table";
import uRLs from "../../../utils/baseUtils";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import {
  ChevronRightIcon,
  CircleIcon,
  CustomersIcon,
  DownloadIcon,
  EditIcon,
  RefreshIcon,
  SearchIcon,
  ShowIcon,
  SortDownIcon,
  SpreadSheetIcon,
  UploadIcon,
  XIcon,
} from "../../../constants/Icons";
import { capitalizeFirstLetter } from "../../../templates/modules/invoiceUtils";

const Customer = ({ isActive }) => {
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCustomerData, setCustomerData] = useState([]);
  const [isGroupLoading, setIsGroupLoading] = useState(false);
  const [selectedGroupDetails, setSelectedGroupDetails] = useState(null);
  const searchInputRef = useRef(null);
  const containerRef = useRef(null);
  const customerSuggestionsRef = useRef(null);
  const suggestionRefs = useRef([]);
  const [addGroupload, setAddGroupLoad] = useState(false);
  const { updateSettings, isUser } = useAuth();
  const [numberSuggest, setNumberSuggest] = useState([]);
  const navigate = useNavigate();
  const [isSearchTerm, setSearchTerm] = useState("");
  const [customerSuggestions, setCustomerSuggestions] = useState([]);
  const [selectedCustomerPhone, setSelectedCustomerPhone] = useState("");
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1); // -1 = none selected
  const [error, setErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [hasSearched, setHasSearched] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const perPage = 10;
  const [index, setIndex] = useState(0);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [isDeleteData, setDeleteData] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [groupName, setGroupName] = useState([]);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);
  const [editGroupOpen, setEditGroupOpen] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const {
    permission,
    hasPermission,
    customerGroups,
    blockedPermissions,
    viewOption,
    globelPopupOpen,
  } = usePermission();
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const [selectAll, setSelectAll] = useState(false);
  const [selectMy, setSelectMy] = useState(false);
  const [newGroupName, setNewGroupName] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState({
    field: "createdAt",
    order: "desc",
  });

  // const numberSuggest=[
  //   {number:"998211212",id:1},{number:"998211213",id:2},{number:"998211214",id:3},{number:"998211215",id:4},{number:"998211216",id:5},{number:"998211217",id:6},
  // ]
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };
  const handleEditGroupClose = () => {
    setEditGroupOpen(false);
  };
  const handleEditGroupOpen = () => {
    if (
      hasPermission("CUSTOMER", "CUSTOMER:updateCustomerGroup") ||
      permission === undefined
    ) {
      setEditGroupOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };
  const handleNewGroupOpen = () => {
    if (
      hasPermission("CUSTOMER", "CUSTOMER:addCustomerGroup") ||
      permission === undefined
    ) {
      setNewGroupOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };
  const handleListCustomer = async (
    page = 0,
    term = "",
    sortbyField = "createdAt",
    sortOrder = "desc",
  ) => {
    if (isLoading) return;
    try {
      if (!checkNetwork()) return;
      setIsLoading(true);
      // const data = { searchtxt: term, pageno: page + 1, limit: perPage };
      let response;
      if (isUser.stype === "MAIN") {
        response = await AxiosInstance.get(
          `module/customer/all?pageno=${
            page + 1
          }&limit=${perPage}&searchtxt=${term}&sortby=${sortOrder}&sortbyField=${sortbyField}`,
        );
      } else {
        response = await AxiosInstance.get(
          `module/customer?pageno=${
            page + 1
          }&limit=${perPage}&searchtxt=${term}&sortby=${sortOrder}&sortbyField=${sortbyField}`,
        );
      }
      const results = response.data.results || [];
      setCustomerData(results);
      if (results.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  // const handleCustomerNumbersuggestion = async () => {
  //   if (!checkNetwork()) return;
  //   try {
  //     const response = await AxiosInstance("module/customer/suggestion/phone");
  //     const result = response.data.results;
  //     setNumberSuggest(result);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const addNewCustomNumber = (phone) => {
    const trimmed = phone?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = numberSuggest?.some(
      (s) => s.phone?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setNumberSuggest((prev) => [
        { _id: Date.now().toString(), phone: trimmed },
        ...prev,
      ]);
    }
  };

  const handleSearch = (term) => {
    if (
      hasPermission("CUSTOMER", "CUSTOMER:search") ||
      permission === undefined
    ) {
      setSearchTerm(term);
      setHasSearched(true);
      setSelectedCustomerPhone("");

      if (!term?.trim()) {
        setCustomerSuggestions([]);
        if (selectedGroupId) {
          handleGroupList(0, " ");
        } else {
          handleListCustomer(0, "");
        }
        setCurrentPage(0);
        return;
      }

      //  Clear previous debounce timer
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      //  Cancel previous API request if still running
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      debounceTimerRef.current = setTimeout(async () => {
        try {
          if (!checkNetwork()) return;
          setSuggestionLoading(true);

          // Create new AbortController for this request
          controllerRef.current = new AbortController();

          let response;
          if (isUser.stype === "MAIN") {
            response = await AxiosInstance.get(
              `module/customer/search?searchtxt=${term?.toLowerCase()}`,
              { signal: controllerRef.current.signal },
            );
          } else {
            response = await AxiosInstance.get(
              `module/customer?searchtxt=${term?.toLowerCase()}`,
              { signal: controllerRef.current.signal },
            );
          }
          setCustomerSuggestions(response.data.results || []);
        } catch (error) {
          if (error.name !== "CanceledError" && error.name !== "AbortError") {
            handleError(error, showAlert);
          }
        } finally {
          setSuggestionLoading(false);
        }
      }, 200);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleSearchFind = () => {
    const currentInputValue = searchInputRef.current?.value || "";
    setSearchTerm(currentInputValue);
    setSelectedCustomerPhone("");
    if (!currentInputValue?.trim()) {
      handleListCustomer(0, "");
    } else {
      handleListCustomer(0, currentInputValue);
    }
    setCustomerSuggestions([]);
    setHasSearched(false);
    setCurrentPage(0);
  };

  const handleSelectCustomer = (customer) => {
    const phone = customer.phone;
    setSearchTerm(phone);
    setSelectedCustomerPhone(phone);
    setCustomerSuggestions([]);
    setHasSearched(false);
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
    handleListCustomer(0, phone);
    setCurrentPage(0);
  };

  const handleOutsideClick = (e) => {
    if (
      customerSuggestionsRef.current &&
      !customerSuggestionsRef.current.contains(e.target)
    ) {
      setCustomerSuggestions([]);
      setHasSearched(false);
    }
  };

  const handleOpenModal = () => {
    if (hasPermission("CUSTOMER", "CUSTOMER:add") || permission === undefined) {
      setModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleView = (customer, index) => {
    setSelectedCustomerId(customer._id); // pass the customer id
    setViewModalOpen(true);
    setIndex(index);
  };
  //like postman
  //     const createCustomerDragPreview = (customer, index) => {
  //   const sno = totalItems - (currentPage * perPage + index);

  //   const preview = document.createElement("div");

  //   // Position off-screen safely
  //   preview.style.position = "fixed";
  //   preview.style.top = "-1000px";
  //   preview.style.left = "-1000px";
  //   preview.style.zIndex = "-9999";

  //   // Postman-like Badge Styling
  //   preview.style.width = "max-content"; // Fits content tightly
  //   preview.style.height = "32px";
  //   preview.style.boxSizing = "border-box";

  //   // Dark background + white text (Postman style - high contrast prevents washed-out look)
  //   preview.style.backgroundColor = "#282828";
  //   preview.style.color = "#ffffff";

  //   preview.style.display = "flex";
  //   preview.style.alignItems = "center";
  //   preview.style.padding = "0 12px";
  //   preview.style.gap = "8px";

  //   preview.style.border = "1px solid #444444";
  //   preview.style.borderRadius = "6px";
  //   preview.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.4)";

  //   preview.style.fontSize = "13px";
  //   preview.style.fontFamily = "Inter, system-ui, sans-serif";
  //   preview.style.fontWeight = "500";
  //   preview.style.whiteSpace = "nowrap";

  //   preview.innerHTML = `
  //     <!-- S.No Badge -->
  //     <span style="
  //       background-color: #383838;
  //       color: #a0a0a0;
  //       font-size: 11px;
  //       font-weight: 600;
  //       padding: 2px 6px;
  //       border-radius: 4px;
  //     ">
  //       ${sno}
  //     </span>

  //     <!-- Status Dot -->
  //     <span style="
  //       width: 7px;
  //       height: 7px;
  //       border-radius: 50%;
  //       background-color: ${
  //         customer?.status === "ACTIVE" ? "#22c55e" : "#9ca3af"
  //       };
  //       flex-shrink: 0;
  //     "></span>

  //     <!-- Customer Name -->
  //     <span style="
  //       font-weight: 600;
  //       color: #ffffff;
  //       max-width: 180px;
  //       overflow: hidden;
  //       text-overflow: ellipsis;
  //       white-space: nowrap;
  //     ">
  //       ${customer?.name || "Customer"}
  //     </span>

  //   `;

  //   document.body.appendChild(preview);

  //   return preview;
  // };
  const createCustomerDragPreview = (customer, index) => {
    const sno = totalItems - (currentPage * perPage + index);

    const preview = document.createElement("div");

    // Keep off-screen
    preview.style.position = "fixed";
    preview.style.top = "-1000px";
    preview.style.left = "-1000px";
    preview.style.zIndex = "-9999";

    // FIX: Set an explicit fixed width instead of "auto"
    preview.style.width = "620px";
    preview.style.height = "38px";
    preview.style.boxSizing = "border-box";

    // Solid background color across the entire container
    preview.style.backgroundColor = "#fff7e9";
    preview.style.color = "#636578";

    preview.style.display = "flex";
    preview.style.alignItems = "center";
    preview.style.padding = "0 12px";
    preview.style.gap = "12px";

    preview.style.border = "1px solid #eadfce";
    preview.style.borderRadius = "5px";
    preview.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";

    preview.style.fontSize = "12px";
    preview.style.fontFamily = "Arial, sans-serif";
    preview.style.fontWeight = "500";
    preview.style.whiteSpace = "nowrap";

    preview.innerHTML = `
      <!-- S.No -->
      <span style="
        flex: 0 0 25px;
        color: #636578;
        font-weight: 600;
        text-align: center;
      ">
        ${sno}
      </span>

      <!-- Status -->
      <span style="
        width: 7px;
        height: 7px;
        min-width: 7px;
        flex-shrink: 0;
        border-radius: 50%;
        background-color: ${customer?.status === "ACTIVE" ? "#39b54a" : "#ccc"};
      "></span>

      <!-- Name -->
      <span style="
        flex: 0 0 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #636578;
        font-weight: 600;
      ">
        ${customer?.name || "-"}
      </span>

      <!-- Phone -->
      ${
        customer?.phone
          ? `
            <span style="
              flex: 0 0 110px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #636578;
            ">
              +91 ${customer.phone}
            </span>
          `
          : ""
      }

      <!-- Email -->
      ${
        customer?.email
          ? `
            <span style="
              flex: 0 0 150px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #636578;
            ">
              ${customer.email}
            </span>
          `
          : ""
      }

      <!-- GST -->
      ${
        customer?.gstnumber
          ? `
            <span style="
              flex: 0 0 120px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #636578;
            ">
              ${customer.gstnumber}
            </span>
          `
          : ""
      }
    `;

    document.body.appendChild(preview);

    return preview;
  };
  const handleAdd = async (newData, resetForm) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...newData,
        shippingAddress: {
          addressline1: newData.shippingaddressline1,
          addressline2: newData.shippingaddressline2,
          district: newData.shippingdistrict,
          city: newData.shippingcity,
          state: newData.shippingstate,
          statecode: newData.shippingstatecode,
          country: newData.shippingcountry,
          pincode: newData.shippingpincode,
        },

        ...(newData.contactPersonname?.trim() ||
        newData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(newData.contactPersonname?.trim() && {
                  name: newData.contactPersonname,
                }),
                ...(newData.contactPersonNumber?.trim() && {
                  number: newData.contactPersonNumber,
                }),
              },
            }
          : {}),
      };
      if (!data.groupid) {
        delete data.groupid;
      }
      const response = await AxiosInstance.post(`module/customer`, data);
      showAlert("success", Messages.SUCCESS.CUSTOMER_ADDED);
      // await handleListCustomer(0);
      const result = response.data.results;
      if (result.name !== newData.name) {
        showAlert(
          "warning",
          `The phone number"${result.phone}" already exists .`,
        );
        // handleCloseModal();
        return true;
      }
      let isLocalDuplicate = false;

      setCustomerData((prev) => {
        if (prev.some((it) => it.name === result.name)) {
          isLocalDuplicate = true;
          return prev;
        } else {
          let newArray = [result, ...prev];

          if (newArray.length > 10) {
            return newArray.slice(0, -1);
          } else {
            return newArray;
          }
        }
      });
      if (isLocalDuplicate) {
        showAlert(
          "warning",
          `The phone number "${result.phone}" already exists in the list.`,
        );
      } else {
        showAlert("success", Messages.SUCCESS.CUSTOMER_ADDED);
        setTotalItems((prevCount) => prevCount + 1);
      }
      resetForm();
      // setCurrentPage(0);
      handleCloseModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //   fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const openEditModal = (cItem) => {
    if (blockedPermissions("CUSTOMER:view") || permission === undefined) {
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const hanleUpdateCustomer = (data) => {
    setCustomerData((prevCustomerData) =>
      prevCustomerData?.map((customer) =>
        customer?._id === data?._id ? data : customer,
      ),
    );
  };

  const handleUpdate = async (updatedData) => {
    showAlert("warning", JSON.stringify(updatedData, null, 2), 15000); // 15 seconds
    const editableKeys = [
      "name",
      "phone",
      "email",
      "addressline1",
      "addressline2",
      "city",
      "district",
      "state",
      "pincode",
      "country",
      "gstnumber",
      "pannumber",
      "cinnumber",
      "referenceid",
      "isPayLater",
      "groupid",
      "website",
      "fssai",
      "tradeName",
      "nickname",
      "contactPersonname",
      "contactPersonNumber",
      "shippingaddressline1",
      "shippingaddressline2",
      "shippingstate",
      "shippingcity",
      "shippingdistrict",
      "shippingpincode",
      "shippingcountry",
    ];

    let hasChange = false;
    for (const key of editableKeys) {
      const originalValue = String(isEditData[key] || "");
      const updatedValue = String(updatedData[key] || "");
      if (originalValue !== updatedValue) {
        hasChange = true;
        break;
      }
    }

    if (!hasChange) {
      showAlert("warning", "No changes detected.");
      return false;
    }

    try {
      if (!checkNetwork()) return;
      setBtnLoading(true);
      const data = {
        ...updatedData,
        shippingAddress: {
          addressline1: updatedData.shippingaddressline1,
          addressline2: updatedData.shippingaddressline2,
          district: updatedData.shippingdistrict,
          city: updatedData.shippingcity,
          state: updatedData.shippingstate,
          statecode: updatedData.shippingstatecode,
          country: updatedData.shippingcountry,
          pincode: updatedData.shippingpincode,
        },

        // ✅ Contact Person Object
        ...(updatedData.contactPersonname?.trim() ||
        updatedData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(updatedData.contactPersonname?.trim() && {
                  name: updatedData.contactPersonname,
                }),
                ...(updatedData.contactPersonNumber?.trim() && {
                  number: updatedData.contactPersonNumber,
                }),
              },
            }
          : {}),
        customerid: updatedData._id,
      };
      const response = await AxiosInstance.patch(
        `module/customer/${updatedData._id}`,
        data,
      );
      showAlert("success", Messages.SUCCESS.CUSTOMER_UPDATED);
      const updatedCustomer = response.data.results;
      const updatedCustomerId = updatedCustomer?._id;
      const originalGroupId = isEditData?.groupid || "";
      const newGroupId = updatedData.groupid || "";
      const groupIdChanged = originalGroupId !== newGroupId;
      if (groupIdChanged) {
        setTotalItems((prevCount) => prevCount + 1);
      }
      setCustomerData((prevCustomerData) => {
        // const originalCustomer = prevCustomerData.find(
        //     (customer) => customer._id === updatedCustomerId
        // );
        // const originalGroupId = originalCustomer?.groupid || "";
        // const newGroupId = updatedCustomer?.groupid || "";

        // const groupIdChanged = originalGroupId !== newGroupId;

        if (groupIdChanged) {
          const filteredData = prevCustomerData.filter(
            (customer) => customer._id !== updatedCustomerId,
          );

          return [updatedCustomer, ...filteredData];
        } else {
          return prevCustomerData.map((customer) =>
            customer._id === updatedCustomerId ? updatedCustomer : customer,
          );
        }
      });
      closeEditModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //   fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const handleNewGroupSet = (results) => {
    setGroupName((prev) => [
      { ...results },
      ...(Array.isArray(prev) ? prev : []),
    ]);
  };

  const handleCustomerGroupAdd = async (groupName) => {
    setAddGroupLoad(true);
    try {
      const data = {
        name: groupName,
      };
      const response = await AxiosInstance.post("module/customer/group", data);
      const results = response.data.results;
      //  setGroupName(results);
      setGroupName((prev) => [
        { ...results },
        ...(Array.isArray(prev) ? prev : []),
      ]);
      updateSettings({
        customerGroups: [
          { ...results },
          ...(Array.isArray(customerGroups) ? customerGroups : []),
        ],
      });
      showAlert("success", "Customer Group Added Successfull");
      setAddGroupLoad(false);
      handleNewGroupClose();
      setNewGroupName(results);
      handleOpenModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setAddGroupLoad(false);
    }
  };
  const handleCustomerGroupEdit = async (groupName, id) => {
    setAddGroupLoad(true);
    try {
      const data = {
        name: groupName,
      };
      const response = await AxiosInstance.patch(
        `module/customer/group/${id}`,
        data,
      );
      const results = response.data.results;
      //  setGroupName(results);
      setGroupName((prev) => {
        if (!Array.isArray(prev)) return [{ ...results }]; // safeguard

        return prev.map((g) =>
          g._id === results._id ? { ...g, ...results } : g,
        );
      });
      updateSettings({
        customerGroups: customerGroups.map((g) =>
          g._id === results._id ? { ...g, ...results } : g,
        ),
      });
      setSelectedGroupDetails(results);
      setAddGroupLoad(false);
      showAlert("success", "Customer Group Updated");
      handleEditGroupClose();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setAddGroupLoad(false);
    }
  };

  const handleGroupList = async (page = 0, term = "") => {
    setIsGroupLoading(true);
    try {
      const response = await AxiosInstance.get(
        `module/customer/group/list?pageno=${page + 1}&limit=${perPage}`,
      );
      const results = response.data.results;
      setGroupName(results);
      setIsGroupLoading(false);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsGroupLoading(false);
    }
  };

  const handleSelectAll = async () => {
    setSelectAll(true);
    setCustomerData("");
    setSelectedGroupId(null);
    setSelectedGroupDetails("");
    setSearchTerm("");
    setCurrentPage(0);
    await handleListCustomer(0, "");
  };

  const handleSelectMy = async () => {
    setSelectMy(true);
    setCustomerData("");
    setSelectedGroupId(null);
    setSelectedGroupDetails("");
    setSearchTerm("");
    setCurrentPage(0);
    await handleListCustomer(0, "");
  };

  const handleGroupCustomerList = async (
    item,
    page = 0,
    sortbyField = "createdAt",
    sortOrder = "desc",
  ) => {
    setIsLoading(true);

    try {
      const response = await AxiosInstance.get(
        `module/customer/grouped/${item._id}?pageno=${
          page + 1
        }&limit=${perPage}&sortby=${sortOrder}&sortbyField=${sortbyField}`,
      );
      const results = response.data.results;
      setCustomerData(results);
      setSelectedGroupId(item._id);
      setSelectedGroupDetails(item);

      isUser.stype === "MAIN" ? setSelectAll(false) : setSelectMy(false);

      if (results.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
      setIsLoading(false);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };
  const openDeleteModal = (cItem) => {
    if (
      hasPermission("CUSTOMER", "CUSTOMER:delete") ||
      permission === undefined
    ) {
      setDeleteData(cItem);
      setDeleteModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleDeleteCustomer = (data) => {
    setCustomerData((prevData) =>
      prevData?.filter((customer) => customer._id !== data?._id),
    );
    setTotalItems((prev) => prev - 1);
  };

  const handleDelete = async () => {
    try {
      if (!checkNetwork()) return;
      setBtnLoading(true);
      // const data = { customerid: isDeleteData._id };
      await AxiosInstance.delete(`module/customer/${isDeleteData._id}`);
      showAlert("success", Messages.SUCCESS.CUSTOMER_DELETED);
      setCustomerData((prevData) =>
        prevData.filter((customer) => customer._id !== isDeleteData._id),
      );

      setTotalItems((prev) => prev - 1);

      // const newTotal = totalItems - 1;
      // const newTotalPages = Math.ceil(newTotal / perPage);

      // if (isCustomerData.length === 1 && currentPage > 0) {
      //   setCurrentPage((prev) => prev - 1);
      //   await handleListCustomer(currentPage - 1, isSearchTerm);
      // } else {
      //   await handleListCustomer(currentPage, isSearchTerm);
      // }

      // setTotalItems(newTotal);
      // setTotalPages(newTotalPages);
      setDeleteModalOpen(false);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleLink = () => {
    const navigatelist = "/customer";
    navigate("/customer-upload", { state: { navigatelist } });
  };

  const exportToCSV = async () => {
    if (isBtnLoading) return;

    try {
      if (!totalItems) {
        showAlert("warning", "No data available to export");
        return;
      }

      if (!checkNetwork()) return;

      setBtnLoading(true);

      const endpoint =
        isUser.stype === "MAIN" ? "module/customer/all" : "module/customer";

      const response = await AxiosInstance.get(
        `${endpoint}?pageno=1&limit=${totalItems}&searchtxt=${encodeURIComponent(
          isSearchTerm || "",
        )}&sortby=${selectedFilter.order}&sortbyField=${selectedFilter.field}`,
      );

      const customers = response.data.results || [];

      if (!customers.length) {
        showAlert("warning", "No data available to export");
        return;
      }

      const headers =
        "Name,NickName,Phone,Email,Role,WholeSale,Group,Address Line 1,Address Line 2,City,District,State,Pincode,Country,GST Number,Pan Number,Cin Number,FSSAI,Business Name,Trade Name,Website,Contact Person Name,Contact Person Number,Reference No,Note,Closing Balance,Balance Side, Paylater Amount,Shipping Address Line 1,Shipping Address Line 2,Shipping City,Shipping District,Shipping State,Shipping Pincode,Shipping Country";

      const clean = (val) => (val ?? "").toString().replace(/[\r\n;]/g, " ");

      const quote = (val) => `"${clean(val).replace(/"/g, '""')}"`;

      const rows = customers
        .map((item) => {
          const row = [
            quote(item?.name),
            quote(item?.nickname),
            quote(item?.phone),
            quote(item?.email),
            quote(item?.role),
            quote(item?.wholesale),
            quote(item?.groupName),
            quote(item?.addressline1),
            quote(item?.addressline2),
            quote(item?.city),
            quote(item?.district),
            quote(item?.state),
            quote(item?.pincode),
            quote(item?.country),
            quote(item?.gstnumber),
            quote(item?.pannumber),
            quote(item?.cinnumber),
            quote(item?.fssai),
            quote(item?.businessname),
            quote(item?.tradeName),
            quote(item?.website),
            quote(item?.contactPerson?.name),
            quote(item?.contactPerson?.number),
            quote(item?.referenceId || item?.referenceid),
            quote(item?.note),
            quote(
              CurrencyConverter.toCurrency(item?.paylaterAmount || 0, "INR"),
            ),
            quote(item?.balanceside),
            quote(
              CurrencyConverter.toCurrency(item?.paylaterAmount || 0, "INR"),
            ),
            quote(item?.shippingAddress?.addressline1),
            quote(item?.shippingAddress?.addressline2),
            quote(item?.shippingAddress?.city),
            quote(item?.shippingAddress?.district),
            quote(item?.shippingAddress?.state),
            quote(item?.shippingAddress?.pincode),
            quote(item?.shippingAddress?.country),
          ];

          return row.join(",");
        })
        .join("\n");

      const csvContent = `${headers}\n${rows}`;
      const BOM = "\uFEFF";

      const blob = new Blob([BOM + csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `CustomerList_${formatDate(new Date())}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setBtnLoading(false);
    }
  };

  const getColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "bg-label-success";
      case "inactive":
        return "bg-label-danger";
      default:
        return "bg-label-secondary";
    }
  };

  useKeyboardTableNavigation({
    isActive,
    containerRef,
    searchTerms: isSearchTerm,
    suggestions: customerSuggestions,
    modals: {
      isModalOpen,
      isViewModalOpen,
      isEditData,
      isDeleteModalOpen,
      addNewGroupOpen,
      editGroupOpen,
      globelPopupOpen,
    },
    onEnter: handleView,
  });
  // useEffect(() => {
  //   const handleArrowAndEnter = (e) => {
  //     // Only handle when search term is empty or suggestions list is empty
  //     if (!(isSearchTerm.trim() === "" || customerSuggestions.length === 0))
  //       return;

  //     if (
  //       isModalOpen ||
  //       isViewModalOpen ||
  //       isEditData ||
  //       isDeleteModalOpen ||
  //       addNewGroupOpen ||
  //       editGroupOpen ||
  //       globelPopupOpen
  //     )
  //       return;

  //     if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

  //     e.preventDefault();

  //     const tableRows = Array.from(document.querySelectorAll("table tbody tr"));
  //     if (!tableRows.length) return;

  //     const currentRow = document.activeElement.closest("tr");
  //     let currentIndex = tableRows.indexOf(currentRow);

  //     // Handle Enter key
  //     if (e.key === "Enter") {
  //       if (currentIndex >= 0) {
  //         const item = tableRows[currentIndex].dataset.item
  //           ? JSON.parse(tableRows[currentIndex].dataset.item)
  //           : null;

  //         if (item) handleView(item);
  //       }
  //       return;
  //     }

  //     // Virtual -1: no row focused yet
  //     if (currentIndex === -1) {
  //       if (e.key === "ArrowDown") {
  //         tableRows[0].tabIndex = 0;
  //         tableRows[0].focus();
  //       } else if (e.key === "ArrowUp") {
  //         tableRows[tableRows.length - 1].tabIndex = 0;
  //         tableRows[tableRows.length - 1].focus();
  //       }
  //       return;
  //     }

  //     // Remove tabIndex from current row
  //     currentRow.tabIndex = -1;

  //     // Calculate next/previous index
  //     let nextIndex =
  //       e.key === "ArrowDown"
  //         ? (currentIndex + 1) % tableRows.length
  //         : (currentIndex - 1 + tableRows.length) % tableRows.length;

  //     const nextRow = tableRows[nextIndex];
  //     nextRow.tabIndex = 0;
  //     nextRow.focus();
  //   };

  //   window.addEventListener("keydown", handleArrowAndEnter);
  //   return () => window.removeEventListener("keydown", handleArrowAndEnter);
  // }, [
  //   isSearchTerm,
  //   customerSuggestions,
  //   isModalOpen,
  //   isViewModalOpen,
  //   isEditData,
  //   isDeleteModalOpen,
  //   addNewGroupOpen,
  //   editGroupOpen,
  //   globelPopupOpen,
  // ]);

  const handleSuggestionNavigation = (e) => {
    if (e.key === "Enter") {
      if (activeIndex >= 0 && customerSuggestions[activeIndex]) {
        e.preventDefault();
        handleSelectCustomer(customerSuggestions[activeIndex]);
      } else {
        e.preventDefault();
        handleSearchFind();
      }
      if (isSearchTerm.trim() === "" || customerSuggestions.length === 0) {
      }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();

      if (isSearchTerm.trim() === "" || customerSuggestions.length === 0) {
      }

      setActiveIndex((prev) =>
        prev < customerSuggestions.length - 1 ? prev + 1 : 0,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : customerSuggestions.length - 1,
      );
    }
  };

  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  // Run once
  useEffect(() => {
    handleGroupList();
    isUser.stype === "MAIN" ? setSelectAll(true) : setSelectMy(true);
  }, []);

  // Focus whenever active
  useEffect(() => {
    if (!isActive) return;

    const timer = setTimeout(() => {
      searchInputRef.current?.focus();
    }, 0);

    return () => clearTimeout(timer);
  }, [isActive]);

  // useEffect(() => {
  //   if (selectedGroupId === null) {
  //     if (
  //       hasPermission("CUSTOMER", "CUSTOMER:list") ||
  //       permission === undefined
  //     ) {
  //       handleListCustomer(currentPage, isSearchTerm);
  //     } else {
  //       showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
  //     }
  //   }
  // }, []);

  const handleFilterChange = (e) => {
    const [field, order] = e.target.value.split("-");
    setSelectedFilter({ field, order });
  };

  // useEffect(() => {
  //   handleCustomerNumbersuggestion();
  // }, []);
  useEffect(() => {
    if (
      !hasPermission("CUSTOMER", "CUSTOMER:list") &&
      permission !== undefined
    ) {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
      return;
    }
    if (selectedGroupId) {
      handleGroupCustomerList(
        selectedGroupDetails,
        currentPage,
        selectedFilter.field,
        selectedFilter.order,
      );
    } else {
      handleListCustomer(
        currentPage,
        isSearchTerm,
        selectedFilter.field,
        selectedFilter.order,
      );
    }
  }, [selectedFilter]);

  const handleGroupChange = (group) => {
    setCurrentPage(0);
    setSelectedGroupDetails(group);
    if (group && group._id) {
      handleGroupCustomerList(group);
    } else {
      isUser.stype === "MAIN" ? setSelectAll(true) : setSelectMy(true);

      setSelectedGroupId(null);
      setSelectedGroupDetails("");
      handleListCustomer();
    }
  };

  const handleRefresh = async () => {
    if (
      !hasPermission("CUSTOMER", "CUSTOMER:list") &&
      permission !== undefined
    ) {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
      return;
    }

    if (selectedGroupId) {
      await handleGroupCustomerList(
        selectedGroupDetails,
        currentPage,
        selectedFilter.field,
        selectedFilter.order,
      );
    } else {
      await handleListCustomer(
        currentPage,
        isSearchTerm,
        selectedFilter.field,
        selectedFilter.order,
      );
    }
  };

  const isReferenceIdVisible = viewOption("customerSettings", "isReferenceId");
  const totalSkeletonColumns = 5 + (isReferenceIdVisible ? 1 : 0);

  const handleDrop = async (e, group) => {
    try {
      const customer = JSON.parse(e.dataTransfer.getData("customer"));

      if (customer.groupid === group._id) {
        showAlert("warning", "Already in this group");
        return;
      }
      const data = {
        customerid: customer._id,
        groupid: group._id,
        country: customer.country,
      };

      await AxiosInstance.patch(`module/customer/${customer._id}`, data);
      if (!selectAll && !selectMy) {
        setCustomerData((prev) =>
          prev.filter((item) => item._id !== customer._id),
        );
        setTotalItems((prev) => prev - 1);
      }
      showAlert("success", Messages.SUCCESS.CUSTOMER_ADDED);
      // handleGroupCustomerList(group);
    } catch (error) {
      handleError(error, showAlert);
    }
  };
  const getCustomerGroupName = (row) => {
    if (row?.group?.name) return row.group.name;
    if (row?.groupid) {
      const group = groupName?.find((group) => group?._id === row.groupid);
      return group?.name || "";
    }

    return "";
  };
  return (
    <div className="page-wrapper">
      <div className="page-content">
        <div className="row">
          <div className="col-lg-2">
            <div className="card">
              <div className="card-header px-3 py-3 d-flex flex-wrap justify-content-between align-items-center gap-3">
                <div className="breadcrumb-title pe-3">Customer Group</div>
              </div>
              {isBtnLoading ? (
                [...Array(4)].map((_, index) => (
                  <ul
                    className="list-group list-group-flush radius-10"
                    key={index}
                  >
                    <li className="cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border">
                      <Skeleton
                        variant="rectangular"
                        className="rounded"
                        width="100%"
                      />
                    </li>
                  </ul>
                ))
              ) : (
                <div className="card-body mb-0">
                  <ul className="list-group  radius-10">
                    {isUser.stype === "MAIN" ? (
                      <li
                        className={`cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border
                     ${selectAll ? "bg-label-infoss" : ""} hover-group`} //bg-label-info
                        onClick={() => handleSelectAll()}
                      >
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center mx-2 flex-grow-1">
                            <CustomersIcon iClass={"me-2 fs-6"} />
                            <h6
                              className={`mb-0 fw-400 ${
                                selectAll ? "bg-label-infoss" : ""
                              }`}
                            >
                              All Customer
                            </h6>
                          </div>
                        </div>
                        <div className="ms-auto">
                          <h6 className="mb-0">
                            <ChevronRightIcon
                              iClass={`${
                                selectAll ? "bg-label-infoss" : ""
                              } font-20`}
                            />
                          </h6>
                        </div>
                      </li>
                    ) : (
                      <li
                        className={`cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border
                     ${selectMy ? "bg-label-infoss" : ""} hover-group`}
                        onClick={() => handleSelectMy()}
                      >
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center mx-2 flex-grow-1">
                            <CustomersIcon iClass={"me-2 fs-6"} />
                            <h6
                              className={`mb-0 fw-400 ${
                                selectMy ? "bg-label-infoss" : ""
                              }`}
                            >
                              My Customer
                            </h6>
                          </div>
                        </div>
                        <div className="ms-auto">
                          <h6 className="mb-0">
                            <ChevronRightIcon
                              iClass={`${selectMy ? "bg-label-infoss" : ""} font-20`}
                            />
                          </h6>
                        </div>
                      </li>
                    )}
                    {groupName?.map((item) => (
                      <li
                        key={item._id}
                        className={`cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border
                      ${selectedGroupId === item?._id ? "bg-label-infoss " : ""}
                         ${dragOverId === item._id ? "bg-label-infoss" : ""}
                         hover-group`}
                        onDragOver={(e) => {
                          e.preventDefault();
                          setDragOverId(item._id);
                        }}
                        onDragLeave={() => setDragOverId(null)}
                        onDrop={(e) => {
                          handleDrop(e, item);
                          setDragOverId(null);
                        }}
                        onClick={() => {
                          setCurrentPage(0);
                          handleGroupCustomerList(item);
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center mx-2 flex-grow-1">
                            <CustomersIcon iClass={"me-2 fs-6"} />
                            <h6
                              className={`mb-0 fw-400 text-break ${
                                selectedGroupId === item?._id
                                  ? "bg-label-infoss"
                                  : ""
                              }`}
                            >
                              {item?.name}
                            </h6>
                          </div>
                        </div>
                        <div className="ms-auto">
                          <h6 className="mb-0">
                            <ChevronRightIcon
                              iClass={`${
                                selectedGroupId === item?._id
                                  ? "bg-label-infoss"
                                  : ""
                              } font-20`}
                            />
                          </h6>
                        </div>
                      </li>
                    ))}
                    {/* {listWallet?.map((item) => (
                        <li
                          key={item?._id}
                          className={`cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border ${
                            selectedWalletId === item?._id
                              ? "bg-label-info "
                              : ""
                          }`}
                          onClick={() => handleViewRechargeWallet(item._id)}
                        >
                          <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center mx-2 flex-grow-1">
                              <i className="bx bx-wallet-alt me-2 fs-5"></i>
                              <h6
                                className={`mb-0 fw-400 ${
                                  selectedWalletId === item?._id
                                    ? "text-primary"
                                    : ""
                                }`}
                              >
                                {item?.walletname} (
                                <span>
                                  {CurrencyConverter.toCurrency(
                                    item?.walletbalance || 0,
                                    "INR"
                                  )}
                                </span>
                                )
                              </h6>
                            </div>
                          </div>
                          <div className="ms-auto">
                            <h6 className="mb-0">
                              <i className="bx bx-chevron-right font-20"></i>
                            </h6>
                          </div>
                        </li>
                      ))} */}
                  </ul>
                  {isUser.stype === "MAIN" && (
                    <div className="row g-3 pt-2">
                      <div className="col-lg-12">
                        <Button
                          text="New Group"
                          icon="ng ng-ng-customers-add-icon"
                          bgColor="bg-label-infos"
                          textColor="text-white"
                          className="text-right w-100"
                          onClick={handleNewGroupOpen}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="col-12 col-lg-10">
            <div className="page-breadcrumb d-flex align-items-center paddingBottom">
              <div className="d-flex align-items-center pe-3">
                <div className="pb-1">
                  <button
                    type="button"
                    className="btn btn-sm btn-light p-1 shadow-none"
                    onClick={handleRefresh}
                    disabled={isLoading}
                    title="Refresh list"
                  >
                    <RefreshIcon iClass={`${isLoading ? "bx-spin" : ""}`} />
                  </button>
                </div>

                <span className="breadcrumb-title">Customers </span>
                {!selectedGroupDetails?._id && (
                  <div className="col-lg-12 ms-3">
                    <div className="position-relative">
                      <div className="input-group" ref={customerSuggestionsRef}>
                        <input
                          type="text"
                          className="form-control"
                          value={isSearchTerm}
                          ref={searchInputRef}
                          onChange={(e) => {
                            handleSearch(e.target.value);
                            setActiveIndex(-1);
                          }}
                          onKeyDown={handleSuggestionNavigation}
                          autoComplete="off"
                          placeholder="Search customer by name, phone, email..."
                        />
                        {isSearchTerm ? (
                          <span
                            className="input-group-text"
                            onClick={() => {
                              setSelectedCustomerPhone("");
                              handleListCustomer();
                              setSearchTerm("");
                            }}
                          >
                            <XIcon />
                          </span>
                        ) : (
                          <button
                            className="input-group-text"
                            onClick={handleSearchFind}
                          >
                            <SearchIcon />
                          </button>
                        )}
                      </div>

                      {hasSearched &&
                        isSearchTerm &&
                        !suggestionLoading &&
                        customerSuggestions.length === 0 && (
                          <ul className="suggestions-list">
                            <li className="suggestion-item text-muted">
                              No customers data was found
                            </li>
                          </ul>
                        )}

                      {customerSuggestions.length > 0 && (
                        <ul className="suggestions-list">
                          {customerSuggestions.map((customer, index) => (
                            <li
                              key={customer._id}
                              ref={(el) => (suggestionRefs.current[index] = el)}
                              onClick={() => handleSelectCustomer(customer)}
                              className={`suggestion-item ${
                                index === activeIndex ? "active-suggestion" : ""
                              }`}
                            >
                              {customer.name} -
                              <span className="badge bg-label-blue rounded-pill ms-1">
                                {customer.phone}
                              </span>
                              {customer.referenceid && (
                                <>
                                  <small>-</small>
                                  <span className="badge bg-label-secondary rounded-pill ms-1">
                                    {customer.referenceid}
                                  </span>
                                </>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  // <>
                  //   -{" "}
                  //   <span
                  //     className="ms-1 d-flex align-items-center justify-content-between badge rounded-10 bg-label-info cursor-poInter p-2"
                  //     onClick={() => handleEditGroupOpen()}
                  //   >
                  //     <span className="me-2">
                  //       <i className="ng ng-ng-customers-icon fs-6"></i>
                  //     </span>
                  //     <span className="text-primary">
                  //       {selectedGroupDetails?.name}
                  //     </span>
                  //     <span className="ms-2">
                  //       <i className="ng ng-ng-edit-icon"></i>
                  //     </span>
                  //   </span>
                  // </>
                )}
              </div>

              <div className="ms-auto d-flex gap-2">
                {uRLs.CUSTOMER_BULK_UPLOAD === "true" && (
                  <div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleLink}
                    >
                      <UploadIcon /> Bulk Upload
                    </button>
                  </div>
                )}
                <div className="dropdown">
                  <button
                    className="btn btn-sm btn-export dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    disabled={isBtnLoading}
                  >
                    {isBtnLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Exporting...
                      </>
                    ) : (
                      <>
                        <DownloadIcon /> Export
                      </>
                    )}
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className={`dropdown-item ${isBtnLoading ? "disabled" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          if (!isBtnLoading) {
                            exportToCSV();
                          }
                        }}
                      >
                        {isBtnLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-1"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Exporting...
                          </>
                        ) : (
                          <>
                            <SpreadSheetIcon />{" "}
                            <span className="icon-text">Excel (CSV)</span>
                          </>
                        )}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="card radius-10 mb-0">
                  <div className="card-body px-0">
                    <div className="row px-3">
                      {selectedGroupDetails?._id && (
                        <div className="col-lg-6 col-12">
                          <>
                            <div className="d-flex align-items-center">
                              <span className="d-flex align-items-center ">
                                <span
                                  className="ms-1 d-flex align-items-center justify-content-between bg-label-infoss badge rounded-10  cursor-poInter p-2"
                                  onClick={() => handleEditGroupOpen()}
                                >
                                  <span className="me-2">
                                    <CustomersIcon iClass={"fs-6"} />
                                  </span>
                                  <span className="bg-label-infoss text-truncate fs-15">
                                    {selectedGroupDetails?.name}
                                  </span>
                                  <span className="ms-2">
                                    <EditIcon />
                                  </span>
                                </span>
                                <span className="ms-1">-</span>
                                <span className="badge btn-label-primary fs-15 ms-1">
                                  {totalItems || 0}
                                </span>
                              </span>
                              <div
                                className="input-group ms-3"
                                style={{ width: "50%" }}
                              >
                                <span className="input-group-text">
                                  <SortDownIcon />
                                </span>
                                <select
                                  className="form-select"
                                  onChange={handleFilterChange}
                                  value={`${selectedFilter.field}-${selectedFilter.order}`}
                                >
                                  <option value="createdAt-desc">
                                    Added On (Newest)
                                  </option>
                                  <option value="createdAt-asc">
                                    Added On (Oldest)
                                  </option>
                                  <option value="normalizedName-asc">
                                    Name (A-Z)
                                  </option>
                                  <option value="normalizedName-desc">
                                    Name (Z-A)
                                  </option>
                                  {viewOption(
                                    "customerSettings",
                                    "isReferenceId",
                                  ) && (
                                    <>
                                      <option value="referenceid-asc">
                                        Reference No (Asc)
                                      </option>
                                      <option value="referenceid-desc">
                                        Reference No (Desc)
                                      </option>
                                    </>
                                  )}
                                </select>
                              </div>
                            </div>
                          </>
                        </div>
                      )}
                      {!selectedGroupDetails?._id && (
                        <div className="col-lg-6 col-12">
                          <>
                            <div className="d-flex align-items-center">
                              <span
                                className="ms-1 d-flex align-items-center justify-content-between badge rounded-10 bg-label-infoss cursor-poInter p-2"
                                // onClick={() => handleEditGroupOpen()}
                              >
                                <span className="me-2">
                                  <CustomersIcon iClass={"fs-6"} />
                                </span>
                                <span className="bg-label-infoss text-truncate fs-15">
                                  {isUser.stype === "MAIN"
                                    ? "All Customer"
                                    : "My Customer"}
                                </span>
                                {/* <span className="ms-2">
                                  <i className="ng ng-ng-edit-icon"></i>
                                </span> */}
                              </span>
                              <span className="ms-1">-</span>
                              <span className="badge btn-label-primary fs-15 ms-1">
                                {totalItems || 0}
                              </span>
                              <div
                                className="input-group ms-3"
                                style={{ width: "50%" }}
                              >
                                <span className="input-group-text">
                                  <SortDownIcon />
                                </span>
                                <select
                                  className="form-select"
                                  onChange={handleFilterChange}
                                  value={`${selectedFilter.field}-${selectedFilter.order}`}
                                >
                                  <option value="createdAt-desc">
                                    Added On (Newest)
                                  </option>
                                  <option value="createdAt-asc">
                                    Added On (Oldest)
                                  </option>
                                  <option value="normalizedName-asc">
                                    Name (A-Z)
                                  </option>
                                  <option value="normalizedName-desc">
                                    Name (Z-A)
                                  </option>
                                  {viewOption(
                                    "customerSettings",
                                    "isReferenceId",
                                  ) && (
                                    <>
                                      <option value="referenceid-asc">
                                        Reference No (Asc)
                                      </option>
                                      <option value="referenceid-desc">
                                        Reference No (Desc)
                                      </option>
                                    </>
                                  )}
                                </select>
                              </div>
                            </div>
                          </>
                        </div>
                      )}
                      {/* {!selectedGroupDetails?._id && (
                        <div className="col-lg-3  col-6 d-flex align-items-center ms-0">
                          <div>
                            <strong>Total Customers: </strong>

                            <span className="badge btn-label-primary fs-15 ms-1">
                              {totalItems || 0}
                            </span>
                          </div>
                        </div>
                      )} */}
                      {/* <div className="col-lg-3 col-12 mb-2 mb-lg-0">
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bx bx-sort-down"></i>
                          </span>
                          <select
                            className="form-select"
                            onChange={handleFilterChange}
                            value={`${selectedFilter.field}-${selectedFilter.order}`}
                          >
                            <option value="createdAt-asc">
                              Created At (Asc)
                            </option>
                            <option value="createdAt-desc">
                              Created At (Desc)
                            </option>
                            {viewOption(
                              "customerSettings",
                              "isReferenceId"
                            ) && (
                              <>
                                <option value="referenceid-asc">
                                  Reference No (Asc)
                                </option>
                                <option value="referenceid-desc">
                                  Reference No (Desc)
                                </option>
                              </>
                            )}
                          </select>
                        </div>
                      </div> */}

                      <div className="col-lg-1 col-6 "></div>
                      <div className="col-lg-5 col-6 d-flex justify-content-end">
                        <button
                          type="button"
                          onClick={handleOpenModal}
                          className="btn bg-label-infos mt-2 mt-lg-0 "
                        >
                          <PersonAddAltRoundedIcon /> Customer
                        </button>
                      </div>
                    </div>
                    <>
                      {/* <div className="table-responsive mt-3">
                        <table className="table align-middle mb-0">
                          <thead className="table-light text-center">
                            <tr>
                              <th>S.No</th>
                              {viewOption(
                                "customerSettings",
                                "isReferenceId"
                              ) && <th>Reference No</th>}
                              <th>Name</th>
                              <th>Phone</th>
                              <th>Email</th> */}
                      {/* <th>State</th>
                              <th>Pincode</th> */}
                      {/* <th>GST Number</th> */}
                      {/* <th>Status</th> */}
                      {/* <th>Actions</th> */}
                      {/* </tr>
                          </thead>
                          <tbody>
                            {isLoading ? (
                              [...Array(9)].map((_, index) => (
                                <tr key={index}>
                                  {[...Array(totalSkeletonColumns)].map(
                                    (__, i) => (
                                      <td key={i} className="text-center">
                                        <Skeleton
                                          variant="text"
                                          width={i === 0 ? 200 : 200}
                                        />
                                      </td>
                                    )
                                  )}
                                </tr>
                              ))
                            ) : isCustomerData.length > 0 ? (
                              isCustomerData.map((item, index) => (
                                <tr
                                  key={item._id || index}
                                  className="position-relative  cursor-poInter hover-row"
                                  onClick={() => handleView(item)}
                                  role="button"
                                  data-item={JSON.stringify(item)}
                                >
                                  <td className="text-center paddingTopBottom"> */}
                      {/* {currentPage * perPage + index + 1} */}
                      {/* {totalItems -
                                      (currentPage * perPage + index)} */}
                      {/* {isCustomerData.length - index} */}
                      {/* {item.status === "ACTIVE" ? (
                                      <span className="rounded fsz-10 ms-1">
                                        <i className="bx bxs-circle text-success"></i>
                                      </span>
                                    ) : (
                                      <span className="rounded fsz-10 ms-1">
                                        <i className="bx bxs-circle text-light-gray"></i>
                                      </span>
                                    )}
                                  </td>
                                  {viewOption(
                                    "customerSettings",
                                    "isReferenceId"
                                  ) && (
                                    <td className="text-center">
                                      {item?.referenceid || "-"}
                                    </td>
                                  )}
                                  <td className="text-center">{item?.name}</td>
                                  <td className="text-center text-heading fw-medium">
                                    +91 {item.phone}
                                  </td>
                                  <td className="text-center">
                                    {item?.email || "-"}
                                  </td> */}
                      {/* <td className="text-center">
                                    {item?.state || "-"}
                                  </td>
                                  <td className="text-center">
                                    {item?.pincode || "-"}
                                  </td> */}
                      {/* <td className="text-center">
                                    {item?.gstnumber || "-"}
                                  </td> */}
                      {/* <td className="text-center">
                                {item.status && (
                                  <span
                                    className={`badge rounded-pill ${getColor(
                                      item.status
                                    )}`}
                                  >
                                    {item.status.charAt(0).toUpperCase() +
                                      item.status.slice(1).toLowerCase()}
                                  </span>
                                )}
                              </td> */}
                      {/* <td className="text-center">
                                    <div className="order-actions opacity-0 opacity-md-100">
                                      <button
                                        type="button"
                                        className="btn-label-info shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleView(item)}
                                        }
                                      >
                                        <i className="bx bx-show"></i>
                                      </button>
                                      <button
                                        type="button"
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openEditModal(item)}
                                        }
                                      >
                                        <i className="ng ng-ng-edit-icon"></i>
                                      </button>

                                      <button
                                        type="button"
                                        className="btn-label-danger shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openDeleteModal(item)
                                        }}
                                      >
                                        <i className="ng ng-ng-delete-icon"></i>
                                      </button>
                                    </div>
                                  </td> */}
                      {/* </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="9"
                                  className="text-center p-2 text-muted"
                                >
                                  <span className="text-muted">
                                    No customers found in the store. add some
                                    customers to get started.
                                  </span>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div> */}
                      <div ref={containerRef}>
                        <Table
                          loading={isLoading}
                          data={isCustomerData}
                          // paddingTopBottom="paddingTopBottom"
                          isDragable={true}
                          onRowDragStart={(e, customer, index) => {
                            e.dataTransfer.setData(
                              "customer",
                              JSON.stringify(customer),
                            );

                            const preview = createCustomerDragPreview(
                              customer,
                              index,
                            );

                            e.dataTransfer.setDragImage(preview, 20, 20);

                            setTimeout(() => {
                              preview.remove();
                            }, 0);
                          }}
                          // onRowDragStart={(e, customer) => {
                          //   e.dataTransfer.setData(
                          //     "customer",
                          //     JSON.stringify(customer),
                          //   );
                          //   // const dragTarget = e.currentTarget;
                          //   // dragTarget.classList.add('dragging-row');
                          //   // e.dataTransfer.setDragImage(dragTarget, 0, 0);

                          //   // setTimeout(() => {
                          //   //     dragTarget.classList.remove('dragging-row');
                          //   // }, 0);
                          // }}
                          onRowClick={(item, index) => handleView(item, index)}
                          columns={[
                            {
                              label: "S.No",
                              key: "",
                              render: (row, index) => {
                                const customerGroupName =
                                  getCustomerGroupName(row);

                                return (
                                  <>
                                    <span
                                      className="d-inline-flex align-items-center justify-content-center"
                                      style={{ minWidth: "55px" }}
                                    >
                                      <span
                                        style={{
                                          width: "32px",
                                          textAlign: "right",
                                          display: "inline-block",
                                        }}
                                      >
                                        {totalItems -
                                          (currentPage * perPage + index)}
                                      </span>
                                      <span
                                        style={{
                                          width: "14px",
                                          marginLeft: "3px",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          justifyContent: "flex-start",
                                        }}
                                      >
                                        {customerGroupName && (
                                          <Tooltip
                                            title={capitalizeFirstLetter(
                                              customerGroupName,
                                            )}
                                            arrow
                                          >
                                            <span className="d-inline-flex align-items-center">
                                              <CustomersIcon iClass="text-infoss ms-1" />
                                            </span>
                                          </Tooltip>
                                        )}
                                      </span>
                                    </span>
                                  </>
                                );
                              },
                              // render: (_, index) => (
                              //   <>
                              //     {totalItems - (currentPage * perPage + index)}
                              //     {_?.status === "ACTIVE" ? (
                              //       <span className="rounded fsz-10 ms-1">
                              //         <CustomersIcon iClass={"text-success ms-1"}/>
                              //       </span>
                              //     ) : (
                              //       <span className="rounded fsz-10 ms-1">
                              //         <CustomersIcon iClass={"text-light-gray ms-1"}/>
                              //       </span>
                              //     )}
                              //   </>
                              // ),
                            },

                            viewOption("customerSettings", "isReferenceId") && {
                              label: "Reference No",
                              key: "referenceid",
                              show: true,
                            },
                            {
                              label: "Name",
                              key: "name",
                              render: (row) => (
                                <Tooltip
                                  title={row?.name || ""}
                                  arrow
                                  placement="top"
                                >
                                  <span
                                    className="text-truncate d-inline-block align-middle"
                                    style={{ maxWidth: "300px" }}
                                  >
                                    {row?.name}
                                  </span>
                                </Tooltip>
                              ),
                            },
                            // { label: "Name", key: "name" },

                            {
                              label: "Phone",
                              tdBodyclass: "tdPadding",
                              render: (row) => `+91 ${row.phone}`,
                            },

                            { label: "Email", key: "email" },

                            {
                              label: "GST Number",
                              thClass: "w-15",
                              render: (row) => (
                                <div className="no-print position-relative">
                                  <div className=" d-flex justify-content-center align-items-center">
                                    <span className="stock-status-badge">
                                      {row?.gstnumber}
                                    </span>
                                    <div className="order-actions order-actions3 opacity-0 opacity-md-100">
                                      <button
                                        type="button"
                                        className="btn-label-info shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleView(row);
                                        }}
                                      >
                                        <ShowIcon />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ),
                            },
                          ].filter(Boolean)}
                        />
                      </div>
                      {totalPages > 0 && (
                        <div className="d-flex justify-content-center mt-3">
                          <ReactPaginate
                            previousLabel={"← Previous"}
                            nextLabel={"Next →"}
                            breakLabel={"..."}
                            onPageChange={({ selected }) => {
                              setIsLoading(true);
                              setCurrentPage(selected);
                              if (selectedGroupId) {
                                handleGroupCustomerList(
                                  selectedGroupDetails,
                                  selected,
                                  selectedFilter.field,
                                  selectedFilter.order,
                                );
                              } else {
                                handleListCustomer(
                                  selected,
                                  isSearchTerm,
                                  selectedFilter.field,
                                  selectedFilter.order,
                                );
                              }
                            }}
                            pageRangeDisplayed={5}
                            pageCount={totalPages}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            activeClassName="active"
                            forcePage={currentPage}
                          />
                        </div>
                      )}
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddCustomer
          isActive={isActive}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onAdd={handleAdd}
          isBtnLoading={isBtnLoading}
          groupId={selectedGroupId}
          selectedGroupDetails={selectedGroupDetails}
          onEditGroupData={handleCustomerGroupEdit}
          groupName={groupName}
          onChangeGroup={handleGroupChange}
          onNewGroupsIn={handleCustomerGroupAdd}
          newGroup={newGroupName}
          error={error}
          setErrors={setErrors}
          numberSuggest={numberSuggest}
          addNewCustomNumber={addNewCustomNumber}
        />
        {isViewModalOpen && (
          <CustomerView
            isOpen={isViewModalOpen}
            onClose={() => setViewModalOpen(false)}
            customerId={selectedCustomerId}
            onUpdate={hanleUpdateCustomer}
            OnDelete={handleDeleteCustomer}
            groupId={selectedGroupId}
            selectAll={selectAll}
            selectMy={selectMy}
            isActive={isActive}
            selectedGroupDetails={selectedGroupDetails}
            onEditGroupData={handleCustomerGroupEdit}
            onChangeGroup={handleGroupChange}
            setCustomerData={setCustomerData}
            setCustTotalItems={setTotalItems}
            onNewGroupsSet={handleNewGroupSet}
            customerList={isCustomerData}
            index={index}
            totalCustomer={totalItems}
            setIndex={setIndex}
          />
        )}

        {isEditModalOpen && (
          <EditCutomer
            isActive={isActive}
            editData={isEditData}
            onClose={closeEditModal}
            onEdit={handleUpdate}
            isBtnLoading={isBtnLoading}
            groupId={selectedGroupId}
            selectedGroupDetails={selectedGroupDetails}
            onEditGroupData={handleCustomerGroupEdit}
            groupName={groupName}
            onChangeGroup={handleGroupChange}
            onNewGroupsIn={handleCustomerGroupAdd}
            newGroup={newGroupName}
            error={error}
            setErrors={setErrors}
          />
        )}

        {isDeleteModalOpen && (
          <DeleteModal
            onClose={() => setDeleteModalOpen(false)}
            onConfirm={handleDelete}
            isLable={" Customer " + isDeleteData?.name}
            isBtnLoading={isBtnLoading}
          />
        )}
        {addNewGroupOpen && (
          <AddGroup
            onClose={handleNewGroupClose}
            onNewGroupIn={handleCustomerGroupAdd}
            isBtnLoading={addGroupload}
          />
        )}
        {editGroupOpen && (
          <EditGroup
            onClose={handleEditGroupClose}
            onNewGroupIn={handleCustomerGroupEdit}
            isBtnLoading={addGroupload}
            onData={selectedGroupDetails}
          />
        )}
      </div>
    </div>
  );
};

export default Customer;
